import { addFieldEditor } from "aldoo-ra/CMS/field-editor-resolver"
import PlatformProductEditor from "./editors/platform-product-editor"

export const PlatformProductType = {
    id: "PlatformProduct",
    label: "Platform Product Configuration",
    labelField: "platform",
    fields: [
        {
            id: "platform",
            label: "Platform",
            type: "Text",
            required: true,
            options: ["iOS", "Android", "Web", "Windows"],
            description: "Platform identifier",
            default: "iOS",
            variant: "admin_large",
            render: {
                enableResetButton: false
            }
        },
        {
            id: "id",
            label: "Product ID",
            type: "Text",
            description: "Platform-specific product identifier",
            variant: "admin_large",
            required: true
        }
    ]
};

// Register the platform product editor
addFieldEditor("PlatformProductEditor", PlatformProductEditor);

// Note: PlatformProduct is an embedded type used within PriceModel
// So it doesn't need RegisterInDBResolver = true